"use client";

import {
  Avatar,
  Flex,
  HoverCard,
  Indicator,
  Stack,
  Text,
  Title,
} from "@mantine/core";

import { ProfileData } from "@/builders/types/profile";
import { ProfilePopoverContent } from "../profile/profile-popover";
import { ProfileDrawer } from "../profile/staff/profile-drawer";

interface ProfilePopoverProps extends Partial<ProfileData> {}

export function ProfilePopover(props: ProfilePopoverProps) {
  const { first_name, email, last_name } = { ...props };

  return (
    <>
      <HoverCard
        offset={40}
        position="right-end"
        styles={{
          dropdown: {
            width: "fit-content",
            overflow: "hidden",
            padding: 0,
          },
        }}
      >
        <HoverCard.Target>
          <Flex gap={8} align="center">
            <Indicator
              inline
              size={16}
              offset={7}
              position="bottom-end"
              color="green"
              withBorder
            >
              <Avatar color="white" size="lg" radius="xl" src={props?.image} />
            </Indicator>

            <Stack gap={0}>
              <Title
                order={3}
                className="prose-sm/semi-bold text-primary-background-white"
              >
                {first_name} {last_name}
              </Title>

              <Text c="accent.7" className="truncate prose-sm/semi-bold">
                {email}
              </Text>
            </Stack>
          </Flex>
        </HoverCard.Target>

        <HoverCard.Dropdown miw={240}>
          <ProfilePopoverContent {...props} />
        </HoverCard.Dropdown>
      </HoverCard>

      <ProfileDrawer />
    </>
  );
}
